import React, { FC } from "react";
import cn from "classnames";
import { Editor } from "@tiptap/react";
import { camelize } from "src/utils/camelize";
import { Button } from "src/components/Button";
import { ButtonVariants } from "src/components/Button/types";
import { IFontFormatButton } from "./types";

interface Props extends IFontFormatButton {
  editor: Editor;
}
export const FontFormatButton: FC<Props> = ({ editor, format, icon: Icon }) => {
  const isActive = editor.isActive(format);

  const onClick = () => {
    const methodName = camelize(`toggle ${format}`); // ex. "toggle bold" => toggleBold
    editor.chain().focus()[methodName]?.().run();
  };

  return (
    <Button
      type="button"
      className="!rounded-md !duration-100 !p-1"
      variant={isActive ? ButtonVariants.PRIMARY : ButtonVariants.SECONDARY}
      onClick={onClick}
    >
      <Icon
        title={format}
        className={cn("w-5 h-5 transition-colors duration-100", {
          "text-black-base ": !isActive,
          "text-white-base": isActive,
        })}
      />
    </Button>
  );
};
